import React from "react";
import { Form, Input, Select, Row, Col } from "antd";
const { Option } = Select;
const DoctorForm = ({ form, initialFormData }) => {
  const isDisabled = !!initialFormData;
  return (
    <Form form={form} layout="vertical" initialValues={initialFormData}>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="salutation"
            label="Salutation"
            rules={[{ required: true, message: "Please select a salutation!" }]}
          >
            <Select placeholder="Select a salutation">
              <Option value="Mr.">Mr.</Option>
              <Option value="Miss.">Miss.</Option>
              <Option value="Mrs.">Mrs.</Option>
              <Option value="Ms.">Ms.</Option>
              <Option value="Dr.">Dr.</Option>
              <Option value="Prof.">Prof.</Option>
              <Option value="A/Prof.">A/Prof.</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="first_name"
            label="First Name"
            rules={[
              { required: true, message: "Please enter the first name!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="last_name"
            label="Last Name"
            rules={[{ required: true, message: "Please enter the last name!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={10}>
          <Form.Item
            name="phone_number"
            label="Phone Number"
            rules={[{ message: "Please enter the phone number!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={2}></Col>
        <Col span={12}>
          <Form.Item
            name="email_address"
            label="Email Address"
            rules={[
              { required: true, message: "Please enter the email address!" },
            ]}
          >
            <Input
              disabled={isDisabled}
              style={{
                backgroundColor: isDisabled && "#e8e8e8",
                color: isDisabled && "black",
                cursor: isDisabled && "not-allowed",
                textTransform: "lowercase",
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      {!initialFormData && (
        <Row>
          <Col span={10}>
            <Form.Item
              name="company_id"
              label="Company ID"
              rules={[
                { required: true, message: "Please enter the company ID!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col span={12}>
            <Form.Item
              name="password"
              label="Password"
              rules={[
                { required: true, message: "Please enter the company ID!" },
              ]}
            >
              <Input.Password placeholder="Password" />
            </Form.Item>
          </Col>
        </Row>
      )}
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="gender"
            label="Gender"
            rules={[{ required: true, message: "Please enter the gender!" }]}
          >
            <Select placeholder="Select a gender">
              <Option value="Male">Male</Option>
              <Option value="Female">Female</Option>
              <Option value="Unspecified">Unspecified</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="date_of_birth"
            label="Date of Birth"
            rules={[
              { required: true, message: "Please enter the date of birth!" },
            ]}
          >
            <Input type="date" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="clinic"
            label="Clinic"
            rules={[{ required: true, message: "Please enter the clinic!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item name="professional_profile" label="Professional Profile">
            <Input.TextArea />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item name="medical_registration" label="Medical Registration">
            <Input.TextArea />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item name="specialties" label="Specialties">
            <Input.TextArea />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item name="qualifications" label="Qualifications">
            <Input.TextArea />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default DoctorForm;
